import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhUsersThree } from 'ember-phosphor-icons';
import BenefitCard from 'tio-employee/components/dashboard-kit/benefit-card';
import {
  RECENTLY_ADDED_DAYS,
  type Headcount,
} from 'tio-employee/utils/partner-dashboard/sources/headcount';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Pertinent card: how many employees participate, are invited but unregistered, or were just added. */
const EmployeesHeadcountWidget: TOC<WidgetComponentSignature<Headcount>> = <template>
  <BenefitCard
    @title={{t "partner_dashboard.headcount.title"}}
    @icon={{PhUsersThree}}
    @actionLabel={{t "partner_dashboard.headcount.manage_action"}}
    @actionRoute="authenticated.admin.employees"
    data-test-partner-dashboard-headcount
  >
    <dl class="grid grid-cols-1 gap-3 sm:grid-cols-[repeat(auto-fit,minmax(140px,1fr))]">
      <div class="tio-col-extra-tight" data-test-partner-dashboard-headcount-stat="participating">
        <dt class="tio-text-sm-medium tio-fg-secondary">{{t
            "partner_dashboard.headcount.participating"
          }}</dt>
        <dd class="tio-text-lg-semibold tio-fg-primary">{{@data.participating}}</dd>
      </div>
      <div class="tio-col-extra-tight" data-test-partner-dashboard-headcount-stat="pending">
        <dt class="tio-text-sm-medium tio-fg-secondary">{{t
            "partner_dashboard.headcount.pending"
          }}</dt>
        <dd class="tio-text-lg-semibold tio-fg-primary">{{@data.pending}}</dd>
      </div>
      <div class="tio-col-extra-tight" data-test-partner-dashboard-headcount-stat="added">
        <dt class="tio-text-sm-medium tio-fg-secondary">{{t
            "partner_dashboard.headcount.recently_added"
            days=RECENTLY_ADDED_DAYS
          }}</dt>
        <dd class="tio-text-lg-semibold tio-fg-primary">{{@data.recentlyAdded}}</dd>
      </div>
    </dl>
  </BenefitCard>
</template>;

export default EmployeesHeadcountWidget;
